export default __webpack_public_path__ + "static/media/Mastercard.86d07cbb.svg";